import { Component } from "@angular/core";
import { UserService } from "../../services/user.service";
import { ProfileService } from "../../services/profile.service";
import { Auth } from "@angular/fire/auth";
import { RouterOutlet } from "@angular/router";
import { ThemeService } from "src/app/services/theme.service";
import { AccountService } from "src/app/services/account.service";

@Component({
  selector: "vl-authorized",
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: "./authorized.component.html",
  styleUrl: "./authorized.component.scss",
})
export class AuthorizedComponent {
  constructor(
    private auth: Auth,
    private userService: UserService,
    private profileService: ProfileService,
    private accountService: AccountService,
    private themeService: ThemeService,
  ) {
    // Check if user is logged in, if so, get token, get and set profile details
    this.auth.onAuthStateChanged((user) => {
      if (user) {
        // Set the user
        this.userService.setUser(user);
        this.userService.setUser$(user);
        
        // Get token
        user.getIdToken().then((token) => {
          // Set token
          this.userService.setToken(token);

          // Get profile
          this.profileService.getOrCreateProfile(user).subscribe((profile) => {
            // Set profile
            this.profileService.setProfile(profile);
            this.profileService.setProfile$(profile);

            //Set theme
            this.themeService.setTheme(profile.theme = 'system');

            // Get accounts
            this.accountService.getAccountsByProfileId(profile._id).subscribe((accounts) => {
              // Set first account for now
              this.accountService.setAccount(accounts[0]);
              this.accountService.setAccount$(accounts[0]);
              
            })
            
          });

        });
      }
    });

    // When token is updated, get and set user token
    this.auth.onIdTokenChanged((user) => {
      // Get token
      user?.getIdToken().then((token) => {
        // Set token
        this.userService.setToken(token);
      });
    });
  }
}
